import React, { useState, useEffect } from 'react'
import { Table, Panel, IconButton, Icon, Grid, Row, Col } from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import DashboradToggle from '../dashboard/DashboradToggle'

export default function WaitingForReview({ config, onSettingChange = () => {} }) {
  const { Column, HeaderCell, Cell } = Table
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const getIcon = (key) => {
    if (key == 1) {
      return 'file-o'
    } else if (key == 2) {
      return 'copy-o'
    } else if (key == 3) {
      return 'building2'
    }
  }
  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              width: 40,
              height: 40,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={getIcon(rowData[dataKey]?.value)}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
            {rowData[dataKey]?.name}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={config.show}
          style={{ marginTop: 20, marginBottom: -15 }}
        />
      )}
      <Panel header={schema?.header} bordered collapsible defaultExpanded shaded>
        <Table
          wordWrap
          height={400}
          loading={isLoading}
          autoHeight={schema?.values?.length <= 5}
          data={schema?.values || []}
        >
          <Column width={130} align="center">
            <HeaderCell>
              <span>{schema?.codeText}</span>
            </HeaderCell>
            <Cell dataKey="code" />
          </Column>
          <Column width={450} flexGrow={1} align="left">
            <HeaderCell align="center">
              <span>{schema?.nameText}</span>
            </HeaderCell>

            <Cell dataKey="name" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.typeText}</span>
            </HeaderCell>
            <ImageCell dataKey="type" />
          </Column>
          <Column width={120} align="right">
            <HeaderCell align="center">
              <span>{schema?.budgetText}</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.budget)
              }}
            </Cell>
          </Column>
          <Column width={130} align="center" fixed="right">
            <HeaderCell align="center"></HeaderCell>

            <Cell>
              {(rowData) => {
                return (
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="filter" className="bt-gost-icon-radius" />}
                    style={{ float: 'right', marginBottom: 20 }}
                    onClick={(e) => {
                      // history.push(`${pathname.proposal.overview.overviewCoworker}/${rowData.id}`)

                      sessionStorage.setItem('projectId', rowData.id)
                      sessionStorage.setItem('param', '')

                      history.push(`${pathname.proposal.overview.overviewCoworker}`)
                    }}
                  >
                    {schema?.buttonText || 'คัดกรอง'}
                  </IconButton>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}

const mockSchema = {
  header: 'โครงการที่รอคัดกรอง',
  codeText: 'รหัสโครงการหลัก',
  nameText: 'ชื่อโครงการหลัก',
  typeText: 'ประเภทโครงการ',
  budgetText: 'งบประมาณรวม',
  buttonText: 'คัดกรอง',
  values: [
    {
      id: '42E5F48A-154A-4942-A08C-E0A9FD659511',
      code: '60-001000',
      name: 'การจัดการขยะในชุมชน',
      budget: 5444273.5,
      type: {
        value: '3',
        name: 'แผนงาน',
      },
    },
    {
      id: 'F08C927F-2F81-40A8-B673-3DE67648C379',
      code: '60-001002',
      name: 'ลด ละ เลิก การดื่มแอลกอฮอล์ในชุมชน',
      budget: 5009724.0,
      type: {
        value: '2',
        name: 'ชุดโครงการ',
      },
    },
    {
      id: '1A5025C6-9997-4B22-862F-159DD56EE11E',
      code: '60-001004',
      name: 'การจัดการจุดเสี่ยงเพื่อป้องกันอุบัติเหตุทางถนนในชุมชน',
      budget: 9530940.0,
      type: {
        value: '1',
        name: 'โครงการ',
      },
    },
    {
      id: 'BAB78D89-6CF1-4479-9210-A8C331B057C7',
      code: '60-001006',
      name: 'ลด ละ เลิก การดื่มแอลกอฮอล์ในชุมชน',
      budget: 4971901.0,
      type: {
        value: '1',
        name: 'โครงการ',
      },
    },
    {
      id: '9BE3B891-FD65-416B-8459-7AD624B5D3F2',
      code: '60-001008',
      name: 'โครงการพลเมืองไทยสู้ภัยโควิด ปี 2564',
      budget: 2983185.0,
      type: {
        value: '3',
        name: 'แผนงาน',
      },
    },
    {
      id: '8AE9D782-173A-41EE-96B1-54DD6AF2D746',
      code: '60-001009',
      name: 'ทดสอบโครงการเปิดรับทั่วไป',
      budget: 2983185.0,
      type: {
        value: '3',
        name: 'แผนงาน',
      },
    },
  ],
}
